<template>
  <div class="checkbox content-centered" :class="{active: checked, TA:isTestAchat}" @click="change()">
    <SvgIcon v-if="icon" :icon="icon" class="icon content-centered" :class="{radio : radio || round}" fill />
    <h1 class="label" v-if="label">{{ label }}</h1>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  model: {
    prop: "output",
    event: "change",
  },
  computed: {
    ...mapGetters("subscription", ["isTestAchat"]),
    checked() {
      return !this.radio ? this.output.indexOf(this.value) !== -1 : this.output === this.value;
    },
  },
  props: {
    output: [Array, String],
    label: {
      type: String,
      required: false,
    },
    icon: {
      type: String,
      required: false,
    },
    value: {
      type: String,
      required: true,
    },
    radio: {
      type: Boolean,
      required: false,
    },
    round: {
      type: Boolean,
      required: false
    }
  },
  methods: {
    change() {
      if (this.radio === false) {
        let index = this.output.indexOf(this.value);

        if (index === -1) {
          this.output.push(this.value);
        } else {
          this.output.splice(index, 1);
        }
        this.$emit("change", this.output);
        this.$emit("checked", this.checked);
      }
      else {
        this.$emit("change", this.value);
        this.$emit("checked", this.checked);
      }
    },

  },
};
</script>

<style lang="scss" scoped>
.checkbox {
  cursor: pointer;
  display: flex;
  // flex-direction: row;

  .label {
    display: block;
    flex: 1;
    text-align: center!important;
    margin: 5px 0!important;
    // margin-left: 10px!important;
    font-size: 0.8rem!important;
    padding: 0!important;
    border-radius: 0!important;
    background: none!important;
  }

  .icon {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.3rem;
    width: 35px;
    height: 35px;
    border: 1px solid $grey;
    border-radius: 20%;
    background: $white;
    color: $grey;
    box-shadow: 5px 10px 10px #4d545a12;

    &.radio {
      border-radius: 50%;
    }
  }

  &.secondary .icon {
    width: 60px;
    height: 60px;
  }

  .check-button {
    margin-top: $margin;
    width: 20px;
    height: 20px;
    border: 2px solid #969A9D;

    &.radio {
      border-radius: 50%;
    }
  }

  &.disabled {
    .check-button {
      border: 2px solid #ccc;
      background: #ccc;
    }
  }

  &.active {
    .icon {
      color: $black;
      border: 1px solid $yellow;
      background: $clearYellow;
    }

    .check-button {
      border: 2px solid $yellow;
      background: $yellow;
      position: relative;

      &::before {
        content: url("~@/assets/icons/icon-check.svg");
        position: absolute;
        top: 1px;
        bottom: 0;
        left: 1px;
        right: 1px;
      }
    }
  }
}

.TA {
  .checkbox {
    &.active {
      .icon {
        border: 1px solid $pink;
        background: $pink;

        /deep/ svg {
          fill: $white;
        }
      }

      .check-button {
        border: 2px solid $pink;
        background: $pink;
        &::before {
          content: url("~@/assets/icons/icon-check-white.svg");
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Form/SimulationFields/CheckField.vue